import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const holidaysApi = {
  getHolidays: async (params: any = {}) => {
    const { page = 1, limit = 10 } = params;
    const response = await axios.get(
      `${API_URL}/api/admin/holidays?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  createHoliday: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/holidays`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  applyHoliday: async (id: string) => {
    const response = await axios.post(
      `${API_URL}/api/admin/holidays/${id}/apply`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  deleteHoliday: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/holidays/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },
};

export default holidaysApi;
